<div *adaptLoading="isLoading">
    @if (!!data?.averageCareerValuation) {
        <dx-chart [pathModified]="true"
                  [dataSource]="data?.categoryStats || []"
                  (onInitialized)="onInitialized($event)">
            <dxo-chart-size [height]="300"> </dxo-chart-size>
            <dxi-chart-series valueField="averageActual"
                              name="Actual"> </dxi-chart-series>
            <dxi-chart-series valueField="averageDifferential"
                              name="Differential"> </dxi-chart-series>
            <dxo-chart-legend [visible]="false"></dxo-chart-legend>
            <dxo-chart-common-series-settings argumentField="name"
                                              type="stackedbar"
                                              tagField="id">
                <dxo-chart-label [visible]="false"></dxo-chart-label>
            </dxo-chart-common-series-settings>
            <dxi-chart-value-axis visualRangeUpdateMode="keep"
                                  [visualRange]="[0, null]"> </dxi-chart-value-axis>
            <dxo-chart-argument-axis>
                <dxo-chart-label overlappingBehavior="stagger"
                                 wordWrap="none"></dxo-chart-label>
            </dxo-chart-argument-axis>
            <dxo-chart-tooltip [enabled]="true"
                               [customizeTooltip]="customizeTooltip">
                <dxo-chart-format type="fixedPoint"
                                  [precision]="1"></dxo-chart-format>
            </dxo-chart-tooltip>
        </dx-chart>
    }

    @if (!data?.averageCareerValuation) {
        <div>
            <adapt-no-cultural-measurement label="Career Valuations"></adapt-no-cultural-measurement>
        </div>
    }
</div>
